"use strict";

let BulmaMenu = {
    options: {
        selector: ".navbar-burger",
    },
};

BulmaMenu.init = function (userOptions) {
    for (var prop in userOptions) {
        if (Object.prototype.hasOwnProperty.call(this.options, prop)) {
            this.options[prop] = userOptions[prop];
        }
    }

    this.initSelectors(document);
}

BulmaMenu.initSelectors = function (rootElement) {
    const navbarBurgers = Array.prototype.slice.call(rootElement.querySelectorAll(this.options.selector), 0);

    navbarBurgers.forEach( burger => {
        if (burger.hasOwnProperty('moduleBulmaMenuInitialized')) { return; }
        burger.moduleBulmaMenuInitialized = true;
        burger.addEventListener('click', () => {
            const target = document.getElementById(burger.dataset.target);

            burger.classList.toggle('is-active');
            target.classList.toggle('is-active');
        });
    });
}

export { BulmaMenu };